// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__zACGp","notes":"Notes_notes__-gBaR"};